import React from 'react';
import classname from 'classnames';

export interface HrProps {
  prefixCls?: string;
  className?: string;
  style?: React.CSSProperties;
}

function Hr(props: HrProps) {
  const {
    prefixCls = 'crm-line',
    className,
    style,
  } = props;

  const cls = classname(prefixCls, className);

  return (
    <div
      className={cls}
      style={style}
    >
      &nbsp;
    </div>
  );
}

export default Hr;
